import { Theme } from './theme.service';

export const teamwerkTheme: Theme = {
  logo: 'assets/logos/triarc.svg',
  logoPrint: 'assets/logos/glb-dark.jpg',
  largeLogo: 'assets/logos/glb-large.png',
  cssProperties: {
    primary: '#C0D873',
    'text-primary': '#000',
    'text-primary-accent': '#C0D873',
    accent: '#000',
    'text-accent': '#fff',
    'height-logo': '50px',
    'text-header-bar': '#000',
    toolbar: '#C0D873',
    'text-toolbar-inactive': '#5F7616',
    'text-toolbar-active': '#000',
    'bg-message': '#000',
    'ion-color-primary-contrast': '#000',
    'ion-color-primary': '#C0D873',
    'ion-color-headerbar': '#C0D873',
  },
};
